document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.smart-mega-menu').forEach(function (menu) {
        menu.querySelector('.smart-mega-menu__right-item').style.display = 'grid';
        menu.querySelector('.smart-mega-menu__left-item').classList.add('smart-mega-menu__left-item--active');
        menu.querySelectorAll('.smart-mega-menu__left-item').forEach(function (item) {
            item.addEventListener('click', function () {
                menu.querySelectorAll('.smart-mega-menu__left-item--active').forEach(leftitem => {
                    leftitem.classList.remove('smart-mega-menu__left-item--active');
                });
                menu.querySelectorAll('.smart-mega-menu__right-item').forEach(rightitem => {
                    rightitem.style.display = 'none';
                });
                const target = item.dataset.target;
                menu.querySelector('.smart-mega-menu__right-item[data-secondarytarget="' + target + '"]').style.display = 'grid';
                this.classList.add('smart-mega-menu__left-item--active');
            });
            item.addEventListener('mouseover', function () {
                menu.querySelectorAll('.smart-mega-menu__left-item--active').forEach(leftitem => {
                    leftitem.classList.remove('smart-mega-menu__left-item--active');
                });
                menu.querySelectorAll('.smart-mega-menu__right-item').forEach(rightitem => {
                    rightitem.style.display = 'none';
                });
                const target = item.dataset.target;
                menu.querySelector('.smart-mega-menu__right-item[data-secondarytarget="' + target + '"]').style.display = 'grid';
                this.classList.add('smart-mega-menu__left-item--active');
            });
        });

        if (menu.querySelector('[data-maintarget]')) {
            menu.querySelectorAll('[data-maintarget]').forEach(function (item) {
                item.addEventListener('click', function () {
                    menu.querySelectorAll('.smart-mega-menu__right-item-link--haschildren').forEach(leftitem => {
                        leftitem.classList.remove('smart-mega-menu__right-item-link--haschildren--active');
                    });
                    menu.querySelectorAll('[data-thirdtarget]').forEach(rightitem => {
                        rightitem.style.display = 'none';
                    });
                    const target = item.dataset.maintarget;
                    console.log(target, 'target')
                    menu.querySelectorAll('[data-thirdtarget="' + target + '"]').forEach(target => {
                        target.style.display = 'block'
                    });
                    this.classList.add('smart-mega-menu__right-item-link--haschildren--active');
                });
                item.addEventListener('mouseover', function () {
                    menu.querySelectorAll('.smart-mega-menu__right-item-link--haschildren').forEach(leftitem => {
                        leftitem.classList.remove('smart-mega-menu__right-item-link--haschildren--active');
                    });
                    menu.querySelectorAll('[data-thirdtarget]').forEach(rightitem => {
                        rightitem.style.display = 'none';
                    });
                    const target = item.dataset.maintarget;
                    menu.querySelectorAll('[data-thirdtarget="' + target + '"]').forEach(target => {
                        target.style.display = 'block'
                    });
                    this.classList.add('smart-mega-menu__right-item-link--haschildren--active');
                });
            });
        }
        
    });
    
    var headerWrapper = document.querySelector('.header-wrapper');
    var megaMenu = document.getElementById('Details-HeaderMenu-1');

    // Add a click event listener to the mega menu
    megaMenu.addEventListener('click', function() {
    // Toggle the "active" class on the header-wrapper element
    headerWrapper.classList.toggle('activeheader');
    });


});


